export const ChartFormattingMixin = {
  secondsToMins(seconds, rounding = 0) {
    const value = seconds / 60;
    const rounding_magnitude = 10 ** rounding;
    return Math.round(value * rounding_magnitude) / rounding_magnitude + ' mins';
  },

  secondsToHoursAndMins(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.round((seconds % 3600) / 60);
    return hours + 'h ' + minutes + 'm';
  },

  ticksFormat() {
    return (context) => {
      const value = typeof context === 'object' && context !== null ? context.raw : context;

      switch (this.dataFormatValue) {
        case 'timeDuration':
          return this.secondsToHoursAndMins(value);
        case 'timeDurationMins':
          return this.secondsToMins(value);
        case 'percentage':
          return Math.round(value) + '%';
        default:
          return Math.round(value);
      }
    };
  },

  tooltipFormat() {
    return (context) => {
      const value = typeof context === 'object' && context !== null ? context.raw : context;

      switch (this.dataFormatValue) {
        case 'timeDuration':
          return this.secondsToHoursAndMins(value);
        case 'timeDurationMins':
          return this.secondsToMins(value, 1);
        case 'percentage':
          return Math.round(value) + '%';
        default:
          return Math.round(value);
      }
    };
  },

  setGrace(data) {
    // Get a flat array of y values from all datasets
    const dataValues = data.map((obj) => obj.data).flat();

    // Get the min & max y values
    const maxYValue = Math.max(...dataValues);
    const minYValue = Math.min(...dataValues);

    // Get the range. ChartJS uses this to calculate the grace (50% grace means 50% of this range)
    const range = maxYValue - minYValue;

    // Set expected grace to 50%
    const full_grace = range * 0.5;

    // Return no grace if the resultant value would be less than 0
    if (minYValue - full_grace < 0) {
      return 0;
    }

    // Return no grace if the resultant value would be greater than 100, and the intended data type is percentage
    if (this.dataFormatValue == 'percentage' && maxYValue + full_grace > 100) {
      return 0;
    }

    return '50%';
  },
};
